export default __webpack_public_path__ + "static/cpow-headshot-1e8c7a38dd7580722fc4ab57c649a12b.png";